<template>
    <div class="nav-wrapper">
        <div class="nav-content" id="nav-top">
            <div class="header-logo"><div class="logo"></div></div>
            <div class="header-right">
                <!-- WAP 模式汉堡菜单按钮 -->
                <div
                    v-if="isWap"
                    class="hamburger-menu"
                    @click="toggleMobileMenu"
                ></div>
                <div class="header-pupchase">
                    <a
                        target="_blank"
                        :href="payUrl"
                        @click="mdataButtonClick('header-topup')"
                        class="pupchase-link"
                    >
                        <div
                            class="pupchase"
                            :style="
                                'background-image:url(' + pupchaseImgUrl + ');'
                            "
                        ></div>
                        <div
                            class="off-badge"
                            :style="'background-image:url(' + offBadgeImgUrl + ');'"
                        ></div>
                    </a>
                </div>
                <div class="nav-tab">
                    <div class="home-item-lable"><p>|</p></div>
                    <div class="home-item-tab">
                        <a href="#nav-top">{{ $t("nav.home") }}</a>
                    </div>
                    <div class="game-item-lable"><p>|</p></div>
                    <div class="game-item-tab">
                        <a href="#dw1">{{ $t("nav.game-features") }}</a>
                    </div>
                    <div class="chara-item-lable"><p>|</p></div>
                    <div class="chara-item-tab">
                        <a href="#dw2">{{ $t("nav.characters") }}</a>
                    </div>
                    <div class="fb-item-lable"><p>|</p></div>
                    <a v-if="!showVkLink" :href="fbLink" target="_blank" class="fb-logo"></a>
                    <div v-if="!showVkLink" class="discord-item-lable"><p>|</p></div>
                    <a
                        v-if="!showVkLink"
                        :href="discordLink"
                        target="_blank"
                        class="discord-logo"
                    ></a>
                    <a
                        v-if="showVkLink"
                        :href="vkLink"
                        target="_blank"
                        class="vk-logo"
                    ></a>
                </div>
                <LanguageSelectorImage
                    :languages="availableLangs"
                    :current-language="$i18n.locale"
                    :is-mobile="isWap"
                    @language-change="handleLanguageChange"
                    class="nav-lang-selector"
                    :style="{ top: langSelectorTop }"
                />

                <!-- 旧版语言选择器 (已废弃，保留作为参考)
          <div class="lang-selector" :style="{ top: langSelectorTop }" ref="langSelector">
            <div class="lang-current" @click.stop="toggleLangDropdown">
              <img :src="getCurrentFlag()" class="flag-icon" alt="">
              <span>{{ getCurrentLangName() }}</span>
              <span class="arrow" :class="{ 'arrow-up': showLangDropdown }">▼</span>
            </div>
            <div v-show="showLangDropdown" class="lang-dropdown" @click.stop ref="langDropdown">
              <div 
                v-for="lang in availableLangs" 
                :key="lang.code"
                class="lang-option"
                :class="{ 'active': lang.code === $i18n.locale }"
                @click.stop="switchLanguage(lang.code)"
              >
                <img :src="lang.flag" class="flag-icon" alt="">
                <span>{{ lang.name }}</span>
              </div>
            </div>
          </div>
          -->
            </div>
        </div>

        <!-- WAP 全屏导航菜单 -->
        <transition name="menu-fade">
            <div
                v-if="showMobileMenu"
                class="mobile-menu-overlay"
                @click.self="closeMobileMenu"
            >
                <div class="mobile-menu-content" @click.stop>
                    <!-- 关闭按钮 -->
                    <div class="close-btn" @click="closeMobileMenu">
                        <span></span>
                        <span></span>
                    </div>

                    <!-- Logo -->
                    <div class="menu-logo"></div>

                    <!-- 导航项 -->
                    <nav class="menu-nav">
                        <a
                            href="#nav-top"
                            @click="closeMobileMenu"
                            class="menu-item"
                        >
                            {{ $t("nav.home") }}
                        </a>
                        <a
                            href="#dw1"
                            @click="closeMobileMenu"
                            class="menu-item"
                        >
                            {{ $t("nav.game-features") }}
                        </a>
                        <a
                            href="#dw2"
                            @click="closeMobileMenu"
                            class="menu-item"
                        >
                            {{ $t("nav.characters") }}
                        </a>
                    </nav>

                    <!-- 社交图标 -->
                    <div class="menu-social">
                        <a
                            v-if="!showVkLink"
                            :href="fbLink"
                            target="_blank"
                            class="social-icon fb-icon"
                        ></a>
                        <a
                            v-if="!showVkLink"
                            :href="discordLink"
                            target="_blank"
                            class="social-icon discord-icon"
                        ></a>
                        <a
                            v-if="showVkLink"
                            :href="vkLink"
                            target="_blank"
                            class="social-icon vk-icon"
                        ></a>
                    </div>

                    <!-- 旧版移动端语言选择器 (已废弃，保留作为参考)
          <div class="mobile-lang-selector" ref="mobileLangSelector" @click.stop>
            <div 
              class="lang-current" 
              @click.stop.prevent="handleLangClick"
            >
              <img :src="getCurrentFlag()" class="flag-icon" alt="">
              <span>{{ getCurrentLangName() }}</span>
              <span class="arrow" :class="{ 'arrow-up': showLangDropdown }">▼</span>
            </div>
            <transition name="dropdown-fade">
              <div v-if="showLangDropdown" class="lang-dropdown" @click.stop>
                <div 
                  v-for="lang in availableLangs" 
                  :key="lang.code"
                  class="lang-option"
                  :class="{ 'active': lang.code === $i18n.locale }"
                  @click.stop="switchLanguage(lang.code)"
                >
                  <img :src="lang.flag" class="flag-icon" alt="">
                  <span>{{ lang.name }}</span>
                </div>
              </div>
            </transition>
          </div>
          -->
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import jsonp from "@/utils/jsonp";
import LanguageSelectorImage from "@/components/LanguageSelectorImage.vue";

export default {
    name: "Nav",
    components: {
        LanguageSelectorImage
    },
    data() {
        return {
            payLink: process.env.VUE_APP_PAY_LINK,
            fbLink: process.env.VUE_APP_FB_LINK,
            discordLink: process.env.VUE_APP_DISCORD_LINK,
            vkLink: process.env.VUE_APP_VK_LINK,
            showLangDropdown: false, // 保留给旧代码（已注释）
            showMobileMenu: false,
            isDropdownJustOpened: false, // 保留给旧代码（已注释）
            availableLangs: [
                {
                    code: "en",
                    name: "English"
                },
                {
                    code: "pt",
                    name: "Português"
                },
                {
                    code: "de",
                    name: "Deutsch"
                },
                {
                    code: "fr",
                    name: "Français"
                },
                {
                    code: "es",
                    name: "Español"
                },
                {
                    code: "ar",
                    name: "العربية"
                },
                {
                    code: "ru",
                    name: "Русский"
                },
                {
                    code: "zh",
                    name: "简体中文"
                }
            ]
        };
    },
    props: ["payUrl"],
    computed: {
        showVkLink() {
            return this.$i18n.locale === 'ru';
        },
        pupchaseImgUrl() {
            const locale = this.$i18n.locale;
            const fallbackLocale = this.$i18n.fallbackLocale || "en";
            try {
                return require(`../assets/Nav/${locale}/pupchase.png`);
            } catch (e) {
                try {
                    return require(`../assets/Nav/${fallbackLocale}/pupchase.png`);
                } catch (e2) {
                    console.warn(`[i18n-asset] Missing image: Nav/pupchase.png for locale "${locale}" and fallback "${fallbackLocale}"`);
                    return "";
                }
            }
        },
        offBadgeImgUrl() {
            const locale = this.$i18n.locale;
            try {
                return require(`../assets/Nav/${locale}/off-badge.png`);
            } catch (e) {
                try {
                    return require(`../assets/Nav/off-badge.png`);
                } catch (e2) {
                    return "";
                }
            }
        },
        langSelectorTop() {
            const isCookieAllowed = this.$store.state.cookieAllowed;
            const isWap = this.$store.state.isWap;

            // 根据cookie状态和设备类型动态计算top值
            if (isWap) {
                return isCookieAllowed ? "0.3rem" : "3.4rem";
            } else {
                return isCookieAllowed ? "80px" : "135px";
            }
        },
        isWap() {
            return this.$store.state.isWap;
        }
    },
    methods: {
        mdataButtonClick: function (buttonName) {
            this.$store.dispatch("MDATA_CLICK_BUTTON", buttonName);
        },

        /**
         * 处理语言切换事件（新版组件化方法）
         * @param {String} langCode - 新选择的语言代码
         */
        handleLanguageChange(langCode) {
            this.$i18n.locale = langCode;
            // 保存到cookie
            if (this.$store.state.cookieAllowed) {
                this.setCookie("lang", langCode);
            }
            // 刷新页面以应用新语言，保留URL中的游戏参数
            const params = new URLSearchParams();
            params.set("lang", langCode);
            const urlParams = this.$store.state.urlParams;
            const keys = ['player_token', 'role_id', 'game_code', 'server_id', 'os'];
            keys.forEach(key => {
                if (urlParams[key]) {
                    params.set(key, urlParams[key]);
                }
            });
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?" +
                params.toString();
        },

        /* ========== 以下是旧版语言选择器相关方法（已废弃，保留作为参考） ==========
      handleLangClick() {
        // 移动端直接切换，不需要复杂的时序控制
        this.showLangDropdown = !this.showLangDropdown;
      },
      toggleLangDropdown() {
        this.showLangDropdown = !this.showLangDropdown;
        // 如果打开下拉框，延迟注册点击外部事件，避免立即触发
        if (this.showLangDropdown) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.isDropdownJustOpened = false;
            }, 100);
          });
          this.isDropdownJustOpened = true;
        }
      },
      getCurrentFlag() {
        const currentLang = this.availableLangs.find(lang => lang.code === this.$i18n.locale);
        return currentLang ? currentLang.flag : this.availableLangs[0].flag;
      },
      getCurrentLangName() {
        const currentLang = this.availableLangs.find(lang => lang.code === this.$i18n.locale);
        return currentLang ? currentLang.name : this.availableLangs[0].name;
      },
      switchLanguage(langCode) {
        this.$i18n.locale = langCode;
        this.showLangDropdown = false;
        // 保存到cookie
        if(this.$store.state.cookieAllowed) {
          this.setCookie('lang', langCode);
        }
        // 刷新页面以应用新语言
        window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lang=' + langCode;
      },
      handleClickOutside(event) {
        // 如果移动端菜单打开，不处理点击外部事件（移动端有自己的处理逻辑）
        if (this.showMobileMenu) {
          return;
        }
        
        // 如果下拉框刚刚打开，不处理点击外部事件
        if (this.isDropdownJustOpened) {
          return;
        }
        
        const clickedOutsideLangSelector = this.$refs.langSelector && !this.$refs.langSelector.contains(event.target);
        const clickedOutsideMobileLangSelector = this.$refs.mobileLangSelector && !this.$refs.mobileLangSelector.contains(event.target);
        
        // 如果点击在两个选择器之外,才关闭下拉菜单
        if (clickedOutsideLangSelector && clickedOutsideMobileLangSelector) {
          this.showLangDropdown = false;
        }
      },
      ========== 旧版方法结束 ========== */
        setCookie(cookieName, cookieValue) {
            let expires = "";
            const date = new Date();
            date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 1年
            expires = ";expires=" + date.toUTCString();
            document.cookie = `${cookieName}=${encodeURIComponent(
                cookieValue
            )}${expires};path=/`;
        },
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            // 防止背景滚动
            if (this.showMobileMenu) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        },
        closeMobileMenu() {
            this.showMobileMenu = false;
            document.body.style.overflow = "";
        }
    },
    mounted() {
        // document.addEventListener('click', this.handleClickOutside); // 旧版事件监听，已移除
    },
    beforeDestroy() {
        // document.removeEventListener('click', this.handleClickOutside); // 旧版事件监听，已移除
    }
};
</script>

<style scoped lang="less">
@media (min-width: 1920px) {
    .nav-wrapper {
        width: 100%;
        background-color: #e8e2cb;
    }
    .nav-content {
        position: relative;
        background-color: #e8e2cb;
        background-image: url("../assets/Nav/nav.png");
        background-position: 100% 100%;
        background-size: cover;
        width: 100%;
        height: 0.66rem;
        max-width: 1920px;
        margin: 0 auto;
        .header-logo {
            display: flex;
            align-items: center;
            position: absolute;
            left: 7.8%;
            top: 0.04rem;
            .logo {
                background: url("../assets/Nav/logo.png") no-repeat;
                background-size: cover;
                width: 0.99rem;
                height: 0.54rem;
            }
        }
        .header-pupchase {
            display: flex;
            align-items: center;
            position: absolute;
            left: 22.5%;
            top: 0.08rem;
            .pupchase-link {
                position: relative;
                display: inline-block;
                animation: purchaseGlow 2.5s ease-in-out infinite;
                transition: transform 0.2s ease;
                &:hover {
                    transform: scale(1.07);
                    animation: none;
                    filter: drop-shadow(0 0 0.16rem rgba(255, 220, 60, 1))
                        drop-shadow(0 0 0.4rem rgba(255, 160, 0, 0.9))
                        drop-shadow(0 0 0.6rem rgba(255, 80, 0, 0.5));
                }
            }
            .pupchase {
                margin-right: 0.5rem;
                background-size: cover;
                width: 1.9rem;
                height: 0.51rem;
            }
            .off-badge {
                position: absolute;
                top: -0.06rem;
                right: 0.38rem;
                width: 0.42rem;
                height: 0.42rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                animation: badgeBounce 2.2s ease-in-out infinite;
                pointer-events: none;
            }
        }

        .nav-tab {
            position: absolute;
            font-size: 0.35rem;
            font-weight: 500;
            left: 36.3%;
            width: 55vw;
            height: 10px;
            a {
                text-decoration: none;
            }

            a:hover {
                color: #fef8e4;
            }

            a:visited {
                color: #fef8e4;
            }

            a:link {
                color: #fef8e4;
            }
            .home-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.3rem;
                color: #fef8e4;
                left: 1%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .home-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.3rem;
                left: 10%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .game-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.3rem;
                color: #fef8e4;
                left: 19%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .game-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.3rem;
                left: 32.25%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .chara-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.3rem;
                color: #fef8e4;
                left: 45.5%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .chara-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.3rem;
                left: 55.4%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .fb-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.3rem;
                color: #fef8e4;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
                left: 65%;
            }
            .fb-logo {
                background: url("../assets/Nav/fb.png") no-repeat;
                background-size: cover;
                font-size: 0.3rem;
                position: absolute;
                top: 0.15rem;
                left: 70%;
                white-space: nowrap;
                width: 0.38rem;
                height: 0.38rem;
            }
            .discord-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.3rem;
                color: #fef8e4;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
                left: 78%;
            }
            .discord-logo {
                margin: 0 auto;
                background: url("../assets/Nav/discord.png") no-repeat;
                background-size: cover;
                width: 0.38rem;
                height: 0.38rem;
                font-size: 0.3rem;
                position: absolute;
                top: 0.15rem;
                left: 82%;
                white-space: nowrap;
            }
            .vk-logo {
                margin: 0 auto;
                background: url("../assets/Nav/wk.png") no-repeat;
                background-size: cover;
                width: 0.38rem;
                height: 0.38rem;
                position: absolute;
                top: 0.15rem;
                left: 70%;
                white-space: nowrap;
            }
        }
    }
}
@media (min-width: 1440px) and (max-width: 1919px) {
    .nav-wrapper {
        width: 100%;
    }
    .nav-content {
        position: relative;
        background-image: url("../assets/Nav/nav.png");
        background-position: 100% 100%;
        background-size: cover;
        width: 100%;
        height: 0.66rem;
        .header-logo {
            display: flex;
            align-items: center;
            position: absolute;
            left: 3.8%;
            top: 0.04rem;
            .logo {
                background: url("../assets/Nav/logo.png") no-repeat;
                background-size: cover;
                width: 0.99rem;
                height: 0.54rem;
            }
        }
        .header-pupchase {
            display: flex;
            align-items: center;
            position: absolute;
            left: 16.5%;
            top: 0.08rem;
            .pupchase-link {
                position: relative;
                display: inline-block;
                animation: purchaseGlow 2.5s ease-in-out infinite;
                transition: transform 0.2s ease;
                &:hover {
                    transform: scale(1.07);
                    animation: none;
                    filter: drop-shadow(0 0 0.16rem rgba(255, 220, 60, 1))
                        drop-shadow(0 0 0.4rem rgba(255, 160, 0, 0.9))
                        drop-shadow(0 0 0.6rem rgba(255, 80, 0, 0.5));
                }
            }
            .pupchase {
                margin-right: 0.5rem;
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.9rem;
                height: 0.51rem;
            }
            .off-badge {
                position: absolute;
                top: -0.06rem;
                right: 0.38rem;
                width: 0.42rem;
                height: 0.42rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                animation: badgeBounce 2.2s ease-in-out infinite;
                pointer-events: none;
            }
        }

        .nav-tab {
            position: absolute;
            font-size: 0.35rem;
            font-weight: 500;
            left: 32.3%;
            width: 65vw;
            a {
                text-decoration: none;
            }

            a:hover {
                color: #fef8e4;
            }

            a:visited {
                color: #fef8e4;
            }

            a:link {
                color: #fef8e4;
            }
            .home-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.35rem;
                color: #fef8e4;
                left: 0%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .home-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.35rem;
                left: 6.75%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .game-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.35rem;
                color: #fef8e4;
                left: 13.5%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .game-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.35rem;
                left: 26.75%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .chara-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.35rem;
                color: #fef8e4;
                left: 40%;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
            }
            .chara-item-tab {
                font-size: 0.22rem;
                position: absolute;
                top: 0.35rem;
                left: 50.5%;
                white-space: nowrap;
                height: 100%;
                display: flex;
                align-items: center; /* 垂直居中 */
                transform: translateX(-50%); /* 水平居中 */
            }
            .fb-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.35rem;
                color: #fef8e4;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
                left: 61%;
            }
            .fb-logo {
                background: url("../assets/Nav/fb.png") no-repeat;
                background-size: cover;
                font-size: 0.3rem;
                position: absolute;
                top: 0.15rem;
                left: 64%;
                white-space: nowrap;
                width: 0.38rem;
                height: 0.38rem;
            }
            .discord-item-lable {
                font-weight: 300;
                font-size: 0.24rem;
                position: absolute;
                top: 0.35rem;
                color: #fef8e4;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                height: 100%;
                left: 71.5%;
            }
            .discord-logo {
                margin: 0 auto;
                background: url("../assets/Nav/discord.png") no-repeat;
                background-size: cover;
                width: 0.38rem;
                height: 0.38rem;
                font-size: 0.3rem;
                position: absolute;
                top: 0.15rem;
                left: 75.5%;
                white-space: nowrap;
            }
            .vk-logo {
                margin: 0 auto;
                background: url("../assets/Nav/wk.png") no-repeat;
                background-size: cover;
                width: 0.38rem;
                height: 0.38rem;
                position: absolute;
                top: 0.15rem;
                left: 64%;
                white-space: nowrap;
            }
        }
    }
}
@media (min-width: 940px) and (max-width: 1439px) {
    .nav-wrapper {
        width: 100%;
    }
    .nav-content {
        position: relative;
        background-image: url("../assets/Nav/nav.png");
        background-position: 100% 100%;
        overflow-x: hidden;
        background-size: cover;
        width: 100%;
        height: 0.66rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-logo {
            display: flex;
            align-items: center;
            margin-left: 0.26rem;
            .logo {
                background: url("../assets/Nav/logo.png") no-repeat;
                background-size: cover;
                width: 0.99rem;
                height: 0.54rem;
            }
        }
        .header-right {
            width: 4.95rem;
            height: 0.85rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .header-pupchase {
                width: 1.9rem;
                height: 0.51rem;
                display: flex;
                align-items: center;
                .pupchase-link {
                    position: relative;
                    display: inline-block;
                    animation: purchaseGlow 2.5s ease-in-out infinite;
                    transition: transform 0.2s ease;
                    &:hover {
                        transform: scale(1.07);
                        animation: none;
                        filter: drop-shadow(0 0 0.16rem rgba(255, 220, 60, 1))
                            drop-shadow(0 0 0.4rem rgba(255, 160, 0, 0.9))
                            drop-shadow(0 0 0.6rem rgba(255, 80, 0, 0.5));
                    }
                }
                .pupchase {
                    margin-right: 0.5rem;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 1.9rem;
                    height: 0.51rem;
                }
                .off-badge {
                    position: absolute;
                    top: -0.18rem;
                    right: 0.38rem;
                    width: 0.42rem;
                    height: 0.42rem;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    animation: badgeBounce 2.2s ease-in-out infinite;
                    pointer-events: none;
                }
            }

            .nav-tab {
                width: 1.8rem;
                height: 0.563rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                a {
                    text-decoration: none;
                }

                a:hover {
                    color: #fef8e4;
                }

                a:visited {
                    color: #fef8e4;
                }

                a:link {
                    color: #fef8e4;
                }
                .home-item-lable {
                    display: none;
                }
                .home-item-tab {
                    display: none;
                }
                .game-item-lable {
                    display: none;
                }
                .game-item-tab {
                    display: none;
                }
                .chara-item-lable {
                    display: none;
                }
                .chara-item-tab {
                    display: none;
                }
                .fb-item-lable {
                    display: none;
                }
                .fb-logo {
                    background: url("../assets/Nav/fb.png") no-repeat;
                    background-size: cover;
                    font-size: 0.3rem;
                    white-space: nowrap;
                    width: 0.38rem;

                    height: 0.38rem;
                }
                .discord-item-lable {
                    display: none;
                }
                .discord-logo {
                    margin: 0 auto;
                    background: url("../assets/Nav/discord.png") no-repeat;
                    background-size: cover;
                    width: 0.38rem;
                    height: 0.38rem;
                    font-size: 0.3rem;
                    white-space: nowrap;
                }
                .vk-logo {
                    margin: 0 auto;
                    background: url("../assets/Nav/wk.png") no-repeat;
                    background-size: cover;
                    width: 0.38rem;
                    height: 0.38rem;
                    white-space: nowrap;
                }
            }
        }
    }
}
@media (max-width: 939px) {
    .nav-wrapper {
        width: 100%;
    }
    .nav-content {
        position: relative;
        background-image: url("../assets/Wap/nav.png");
        background-position: 100% 100%;
        overflow-x: hidden;
        background-size: cover;
        width: 100%;
        height: 0.87rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-logo {
            display: flex;
            align-items: center;
            margin-left: 0.26rem;
            .logo {
                background: url("../assets/Wap/logo.png") no-repeat;
                background-size: cover;
                width: 1.27rem;
                height: 0.7rem;
            }
        }
        .header-right {
            /* 汉堡菜单按钮 - 使用绝对定位固定在右侧 */
            .hamburger-menu {
                position: absolute;
                right: 0.4rem;
                top: 50%;
                transform: translateY(-50%);
                width: 0.6rem;
                height: 0.6rem;
                background: url("../assets/Wap/wap_nav.png") no-repeat center;
                background-size: contain;
                cursor: pointer;
                z-index: 998;
                transition: all 0.3s ease;

                &:hover {
                    opacity: 0.8;
                }
            }
            .header-pupchase {
                position: absolute;
                right: 1.3rem;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                align-items: center;
                .pupchase-link {
                    position: relative;
                    display: inline-block;
                    animation: purchaseGlow 2.5s ease-in-out infinite;
                    transition: transform 0.2s ease;
                    &:hover {
                        transform: scale(1.07);
                        animation: none;
                        filter: drop-shadow(0 0 0.16rem rgba(255, 220, 60, 1))
                            drop-shadow(0 0 0.4rem rgba(255, 160, 0, 0.9))
                            drop-shadow(0 0 0.6rem rgba(255, 80, 0, 0.5));
                    }
                }
                .pupchase {
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 1.9rem;
                    height: 0.51rem;
                }
                .off-badge {
                    position: absolute;
                    top: -0.18rem;
                    right: -0.15rem;
                    width: 0.42rem;
                    height: 0.42rem;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    animation: badgeBounce 2.2s ease-in-out infinite;
                    pointer-events: none;
                }
            }

            .nav-tab {
                display: none; /* WAP 模式下隐藏导航栏，使用汉堡菜单替代 */
            }
        }
    }

    /* 移动端全屏菜单 */
    .mobile-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.95);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .mobile-menu-content {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1rem 0.5rem;
        pointer-events: auto;
        margin-top: -1.5rem;
    }

    /* 关闭按钮 - X 形状 */
    .close-btn {
        position: absolute;
        top: 2rem;
        right: 0.5rem;
        width: 0.75rem;
        height: 0.75rem;
        cursor: pointer;
        z-index: 10000;

        span {
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 0.06rem;
            background-color: #fff;

            &:first-child {
                transform: translateY(-50%) rotate(45deg);
            }

            &:last-child {
                transform: translateY(-50%) rotate(-45deg);
            }
        }

        &:hover span {
            background-color: #f4d03f;
        }
    }

    /* Logo */
    .menu-logo {
        width: 4.13rem;
        height: 1.68rem;
        background: url("../assets/Wap/logo.png") no-repeat center;
        background-size: contain;
        margin-bottom: 0.7rem;
    }

    /* 导航项 */
    .menu-nav {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.5rem;

        .menu-item {
            font-size: 0.48rem;
            font-weight: 600;
            color: #fff;
            text-decoration: none;
            letter-spacing: 0.05rem;
            transition: all 0.3s ease;
            padding: 0.25rem 0;
            font-family: source-han-sans-japanese, sans-serif;

            &:hover {
                color: #f4d03f;
                transform: scale(1.1);
            }

            &:active {
                transform: scale(0.95);
            }
        }
    }

    /* 社交图标 */
    .menu-social {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        margin-top: 0.5rem;

        .social-icon {
            width: 0.8rem;
            height: 0.8rem;
            background-size: cover;
            background-repeat: no-repeat;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.2);
            }

            &.fb-icon {
                background-image: url("../assets/Nav/fb.png");
            }

            &.discord-icon {
                background-image: url("../assets/Nav/discord.png");
            }

            &.vk-icon {
                background-image: url("../assets/Nav/wk.png");
            }
        }
    }

    /* 菜单过渡动画 */
    .menu-fade-enter-active,
    .menu-fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .menu-fade-enter,
    .menu-fade-leave-to {
        opacity: 0;
    }

    .menu-fade-enter-active .mobile-menu-content,
    .menu-fade-leave-active .mobile-menu-content {
        transition: transform 0.3s ease;
    }

    .menu-fade-enter .mobile-menu-content {
        transform: scale(0.9);
    }

    .menu-fade-leave-to .mobile-menu-content {
        transform: scale(0.9);
    }

    /* 下拉菜单过渡动画 */
    .dropdown-fade-enter-active {
        animation: dropdown-appear 0.3s ease-out;
    }

    .dropdown-fade-leave-active {
        animation: dropdown-disappear 0.2s ease-in;
    }

    @keyframes dropdown-appear {
        from {
            opacity: 0;
            transform: translateX(-50%) translateY(15px) scale(0.9);
        }
        to {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
        }
    }

    @keyframes dropdown-disappear {
        from {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
        }
        to {
            opacity: 0;
            transform: translateX(-50%) translateY(10px) scale(0.95);
        }
    }
}

/* ========== 新版语言选择器组件样式 ========== */
/* 导航栏中的语言选择器定位 */
.nav-lang-selector {
    position: absolute;
    z-index: 1000;
}

/* ========== 以下是旧版语言选择器样式（已废弃，保留作为参考） ==========
.lang-selector {
  position: absolute;
  cursor: pointer;
  z-index: 1000;
  user-select: none;
}

.lang-current {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border-radius: 4px;
  color: #000;
  font-size: 14px;
  min-width: 100px;
  transition: all 0.3s ease;
}

.lang-current:hover {
  background: rgba(255, 255, 255, 0.1);
}

.flag-icon {
  width: 24px;
  height: 18px;
  border-radius: 2px;
  object-fit: cover;
}

.arrow {
  margin-left: auto;
  font-size: 12px;
  transition: transform 0.3s ease;
  color: #ff7157;
}

.arrow-up {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #6a6158;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s ease;
}

.lang-option:hover {
  background: rgba(71, 71, 71, 0.9);
}

.lang-option.active {
  color: #ff4444;
  font-weight: 500;
}

.lang-option.active:hover {
  background: rgba(71, 71, 71, 0.9);
}
========== 旧版样式结束 ========== */

/* 响应式调整 - 新版组件定位 */
@media (min-width: 1920px) {
    .nav-lang-selector {
        right: 2%;
    }
}

@media (min-width: 1440px) and (max-width: 1919px) {
    .nav-lang-selector {
        right: 2%;
    }
}

@media (min-width: 940px) and (max-width: 1439px) {
    .nav-lang-selector {
        right: 0.2rem;
    }
}

@media (max-width: 939px) {
    /* 隐藏桌面版语言选择器 */
    .nav-lang-selector {
        display: none;
    }
}

/* ========== 以下是旧版响应式样式（已废弃，保留作为参考） ==========
@media (min-width: 1920px) {
  .lang-selector {
    right: 2%;
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .lang-selector {
    right: 2%;
  }
  
  .lang-current {
    min-width: 100px;
    font-size: 13px;
    padding: 6px 12px;
  }
  
  .flag-icon {
    width: 20px;
    height: 15px;
  }
}

@media (min-width: 940px) and (max-width: 1439px) {
  .lang-selector {
    right: 0.2rem;
  }
  
  .lang-current {
    min-width: 100px;
    font-size: 13px;
    padding: 6px 12px;
  }
  
  .flag-icon {
    width: 20px;
    height: 15px;
  }
}

@media (max-width: 939px) {
  .lang-selector {
    display: none;
  }
  
  .mobile-lang-selector {
    position: relative;
    cursor: pointer;
    user-select: none;
    margin-top: 0.6rem;
    z-index: 10001;
    pointer-events: auto !important;
    
    .lang-current {
      display: flex;
      align-items: center;
      gap: 0.15rem;
      padding: 0.25rem 0.5rem;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 0.12rem;
      color: #fff;
      font-size: 0.38rem;
      min-width: 3.2rem;
      justify-content: center;
      transition: all 0.3s ease;
      border: 2px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      cursor: pointer !important;
      pointer-events: auto !important;
      position: relative;
      z-index: 10001;
      
      &:hover {
        background: rgba(255, 255, 255, 0.25);
        border-color: rgba(255, 255, 255, 0.4);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
      }
      
      &:active {
        transform: scale(0.98);
        background: rgba(255, 255, 255, 0.3);
      }
    }
    
    .flag-icon {
      width: 0.55rem;
      height: 0.42rem;
      border-radius: 0.05rem;
      object-fit: cover;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
    
    .arrow {
      margin-left: 0.15rem;
      font-size: 0.28rem;
      transition: transform 0.3s ease;
      color: #fff;
    }
    
    .arrow-up {
      transform: rotate(180deg);
    }
    
    .lang-dropdown {
      position: absolute !important;
      bottom: calc(100% + 0.25rem) !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: 7.2rem !important;
      background: rgba(0, 0, 0, 0.85) !important;
      border-radius: 0.12rem !important;
      overflow: visible !important;
      box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.8) !important;
      border: none !important;
      z-index: 10002 !important;
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      grid-gap: 0.08rem !important;
      padding: 0.15rem !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .lang-option {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 0.1rem !important;
      padding: 0.15rem 0.12rem !important;
      color: #fff !important;
      transition: all 0.2s ease !important;
      border-radius: 0.08rem !important;
      background: transparent !important;
      min-height: 0.55rem !important;
      height: 0.55rem !important;
      text-align: center !important;
      cursor: pointer !important;
      position: relative !important;
      overflow: visible !important;
      
      &:hover {
        background: rgba(255, 255, 255, 0.12) !important;
        transform: scale(1.02) !important;
        box-shadow: none !important;
        z-index: 1 !important;
      }
      
      &.active {
        color: #fff !important;
        font-weight: 700 !important;
        background: rgba(255, 255, 255, 0.15) !important;
        border: none !important;
        box-shadow: none !important;
      }
      
      .flag-icon {
        width: 0.48rem !important;
        height: 0.36rem !important;
        margin-bottom: 0 !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        border-radius: 0.03rem !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;
        flex-shrink: 0 !important;
      }
      
      span {
        white-space: nowrap !important;
        font-size: 0.26rem !important;
        line-height: 1 !important;
        font-weight: 500 !important;
        overflow: visible !important;
        text-overflow: clip !important;
      }
    }
  }
}
========== 旧版响应式样式结束 ========== */

@keyframes badgeBounce {
    0%,
    100% {
        transform: translateY(0) rotate(-8deg) scale(1);
    }
    40% {
        transform: translateY(-0.08rem) rotate(-8deg) scale(1.12);
    }
    70% {
        transform: translateY(-0.03rem) rotate(-8deg) scale(1.05);
    }
}

@keyframes purchaseGlow {
    0%,
    100% {
        background-position: 0% 50%;
        filter: drop-shadow(0 0 0.06rem rgba(255, 220, 60, 0.3))
            drop-shadow(0 0 0.1rem rgba(255, 160, 0, 0.2));
    }
    40% {
        background-position: 100% 50%;
        filter: drop-shadow(0 0 0.16rem rgba(238, 152, 4, 0.9))
            drop-shadow(0 0 0.4rem rgba(238, 152, 4, 0.9))
            drop-shadow(0 0 0.6rem rgba(238, 152, 4, 0.9));
    }
}
</style>
